import Form from 'containers/SignupPages/AuthByContractEpargnEmailCodeInput/Form';
import messages from 'containers/SignupPages/AuthByContractEpargnEmailCodeInput/messages';
import { SEND_EMAIL_VERIFICATION_UNVALID_USER } from 'containers/SignupPages/constants';
import Header from 'containers/SignupPages/Header';
import { translate } from 'helpers/intl';
import React from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { getEmailSelector } from 'store/user/selectors';

export type AuthByEmailType = {
  intl: IntlShape;
  email: string;
  onSubmitStep: Function;
  isLoading: boolean;
  setSignupStep: Function;
};

const AuthEpargnUnvalidUserCodeInput = (props: AuthByEmailType) => {
  return (
    <React.Fragment>
      <Header
        title={translate({ ...messages.title }, props)}
        subTitle={`${translate({ ...messages.subTitle }, props)} ${
          props.email
        }`}
      />
      <Form
        isLoading={props.isLoading}
        onClickPrevious={() => {
          props.setSignupStep(SEND_EMAIL_VERIFICATION_UNVALID_USER);
        }}
        onSubmitStep={props.onSubmitStep}
      />
    </React.Fragment>
  );
};

const mapStateToProps = createStructuredSelector<any, { email: string }>({
  email: getEmailSelector,
});

export default connect(mapStateToProps)(
  injectIntl(AuthEpargnUnvalidUserCodeInput),
);
